module.exports = __webpack_public_path__ + "static/img/Group1.7974f34d.png";